module.exports = __webpack_public_path__ + "media/Images/one-digital-home-hero-d98e49ec9f7806f8f9817db5abf637c7.jpg";